export class Loans {
    currentBalance: number;
    id: number;
    loanDetails : [];
}
